"use strict";
/* eslint-disable no-mixed-operators */
/* eslint-disable no-bitwise */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * RFC4122 version 4 compliant UUID soltion.
 * Reference: https://stackoverflow.com/a/2117523/715597
 */
function uniqueKey() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16);
    });
}
exports.default = uniqueKey;
